export const copyTextToClipboard = async (text: string): Promise<void> => {
  try {
    if (navigator.clipboard) {
      await navigator.clipboard.writeText(text);
    } else {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
};

export const requestFullScreen = (elem: HTMLElement): void => {
  if (elem.requestFullscreen) {
    void elem.requestFullscreen();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
  } else if (elem.mozRequestFullScreen) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    elem.mozRequestFullScreen();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
  } else if (elem.webkitRequestFullScreen) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    elem.webkitRequestFullScreen();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
  } else if (elem.msRequestFullscreen) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    elem.msRequestFullscreen();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
  } else if (elem.webkitEnterFullscreen) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    elem.webkitEnterFullscreen();
  }
};

export const exitFullScreen = (document: Document): void => {
  if (document.exitFullscreen) {
    void document.exitFullscreen();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
  } else if (document.webkitExitFullscreen) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    document.webkitExitFullscreen();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
  } else if (document.mozCancelFullScreen) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    document.mozCancelFullScreen();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
  } else if (document.msExitFullscreen) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    document.msExitFullscreen();
  }
};

export const isEmail = (email: string): boolean => /.+@.*\..{2}/.test(email);
export const isHex = (color: string): boolean => /^#([0-9A-F]{3}){1,2}$/i.test(color);

export const delay = async (ms: number): Promise<void> => new Promise((resolve) => {
  setTimeout(() => resolve(undefined), ms);
});
